import { useEffect, useState } from "react";
import AppLayout from "@/components/AppLayout";
import GameCard from "@/components/GameCard";
import { api, LEAGUES } from "@/lib/api";

export default function Games() {
  const [league, setLeague] = useState("ALL");
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/games", { params: { league } })
      .then((r) => setGames(r.data))
      .catch(() => setGames([]))
      .finally(() => setLoading(false));
  }, [league]);

  return (
    <AppLayout>
      <div className="mb-6 fade-up">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#0A84FF] mb-2">Slate</p>
        <h1 className="font-display font-bold text-4xl md:text-5xl uppercase tracking-tighter">Today's Games</h1>
      </div>
      <div className="flex flex-wrap gap-2 mb-6" data-testid="league-filter">
        {LEAGUES.map((lg) => (
          <button
            key={lg}
            onClick={() => setLeague(lg)}
            data-testid={`league-${lg}`}
            className={`px-4 py-2 text-xs font-black uppercase tracking-[0.15em] rounded-md border transition-colors ${
              league === lg
                ? "border-[#0A84FF] bg-[#0A84FF]/10 text-[#0A84FF]"
                : "border-white/10 text-white/60 hover:text-white hover:border-white/25"
            }`}
          >
            {lg}
          </button>
        ))}
      </div>
      {loading ? (
        <div className="text-white/60 text-sm">Loading slate…</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {games.map((g) => (
            <GameCard key={g.id} game={g} />
          ))}
          {games.length === 0 && <div className="text-white/50">No games for this league.</div>}
        </div>
      )}
    </AppLayout>
  );
}
